import { render, staticRenderFns } from "./ConversionSettingsCreateTab.vue?vue&type=template&id=730446df"
import script from "./ConversionSettingsCreateTab.vue?vue&type=script&lang=ts"
export * from "./ConversionSettingsCreateTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/i18n/views/client-settings/conversion/conversion-settings-create.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusergram-front%2Fsrc%2Fcomponents%2Fclient-settings%2Fconversion%2FConversionSettingsCreateTab.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports